/* global app */

'use strict';

app.factory('sessionFactory', [
    function () {
        return {
            set: function (key, value) {
                return sessionStorage.setItem(key, JSON.stringify(value));
            },

            get: function (key) {
                var value = sessionStorage.getItem(key);

                try {
                    return JSON.parse(value);
                } catch(e) {
                    return value;
                }
            },

            destroy: function () {
                return sessionStorage.clear();
            }
        };
    }
]);
